import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';
import './styles/focus.css';
import PortalFocusTheme from './components/utils/PortalFocusTheme';
import { NavigationGuardProvider } from './components/utils/NavigationGuard';
const PortalApp = lazy(() => import('./App'));
const AdminApp = lazy(() => import('./components/admin/AdminApp'));
const App =
  window.location.origin ===
  process.env.REACT_APP_ADMIN_URL?.replace(/\/+$/, '')
    ? AdminApp
    : PortalApp;

const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <NavigationGuardProvider>
        <Suspense fallback={<div role="progressbar" />}>
          <App />
        </Suspense>
      </NavigationGuardProvider>
    ),
  },
]);

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <PortalFocusTheme />
    <RouterProvider router={router} />
  </React.StrictMode>
);
